import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";
import moment from "moment";
import { SortShipmentOptions } from "@/Shared/Shipment/SortShipmentOptions";

function compareString(
  stringA: string | undefined,
  stringB: string | undefined,
) {
  if (stringB === undefined) {
    return -1;
  }

  if (stringA === undefined) {
    return -1;
  }

  return stringA.localeCompare(stringB);
}

function compareDates(
  dateA: string | undefined,
  dateB: string | undefined,
): number {
  if (dateA === undefined && dateB === undefined) {
    return -1;
  }

  if (dateA === undefined && dateB !== undefined) {
    return -1;
  }

  if (dateA !== undefined && dateB === undefined) {
    return -1;
  }

  if (moment(dateA).isBefore(moment(dateB))) {
    return -1;
  } else {
    return 1;
  }
}

/**
 * Orders two shipments for the sort the customer picked.
 *
 * The date sorts pass their arguments the other way round, so dates run newest
 * first while the text sorts run A to Z.
 */
export function viewShipmentsCompareForSort(
  shipmentA: Shipment,
  shipmentB: Shipment,
  sort: SortShipmentOptions,
): number {
  switch (sort) {
    case SortShipmentOptions.PickupReferenceNumber:
      return compareString(
        shipmentA.pickupReferenceNumber,
        shipmentB.pickupReferenceNumber,
      );
    case SortShipmentOptions.DeliveryReferenceNumber:
      return compareString(
        shipmentA.deliveryReferenceNumber,
        shipmentB.deliveryReferenceNumber,
      );
    case SortShipmentOptions.PickupBusinessName:
      return compareString(
        shipmentA.pickupLocation.businessName,
        shipmentB.pickupLocation.businessName,
      );
    case SortShipmentOptions.DeliveryBusinessName:
      return compareString(
        shipmentA.deliveryLocation.businessName,
        shipmentB.deliveryLocation.businessName,
      );
    case SortShipmentOptions.BookingDate:
      return compareDates(shipmentB.bookedAt, shipmentA.bookedAt);
    case SortShipmentOptions.DeliveryDate:
      return compareDates(
        shipmentB.actualDeliveryDate,
        shipmentA.actualDeliveryDate,
      );
    case SortShipmentOptions.EstimatedDeliveryDate:
      return compareDates(
        shipmentB.expectedDeliveryDate,
        shipmentA.expectedDeliveryDate,
      );
    case SortShipmentOptions.PickupDate:
      return compareDates(shipmentB.pickupDate, shipmentA.pickupDate);
  }
}
